namespace Areas.Employee.Edit {
    "use strict";

    var formUpdate: UpdateOperations;

    $(() => { init(); });

    function init() {
        if ($("#EmployeeForm").dxForm("instance")) {
            formUpdate = new UpdateOperations("EmployeeForm", "/Employee/Edit/Put");
        }
    }


    export function updateRecord(e: any) {
        formUpdate.updateRecord();
    }

    export function userLookupItem(itemData: any, itemIndex: any, itemElement: any) {
        if (itemData.isActive) {
            itemElement.append(
                `<div><span class="collookupspan">${itemData.displayName}</span>${itemData.email}</div>`);
        } else
            itemElement.append(
                `<div style='color:red;font-style:italic'><span class="collookupspan">${itemData.displayName}</span>${
                itemData.email} - Inactive<div>`);
    }

    export function typeValueChanged(e) {
        
        var employeeForm: DevExpress.ui.dxForm = $('#EmployeeForm').dxForm('instance');

        var search = $.map(e.component._dataSource._items, function (user: any) { return user.userId == e.value ? user : null });

        if (search.length > 0) {
            var user = search[0];
            employeeForm.option("formData.UserEmail", user.email);
            employeeForm.option("formData.UserName", user.displayName);
            employeeForm.option("formData.UserLogin", user.loginName);     
        }
    }


    export function supervisorValueChanged(e) {
        var employeeForm: DevExpress.ui.dxForm = $("#EmployeeForm").dxForm("instance");
        var search = $.map(e.component._dataSource._items, function (employee: any) { return employee.employeeId == e.value ? employee : null });

        if (search.length > 0) {
            var employee = search[0];
            employeeForm.option("formData.SupervisorName", employee.displayName);
        }
    }


    export function BeforeSendMaintenance(operation, ajaxSettings) {
        //There is no other way to change the area in the url
        ajaxSettings.url = ajaxSettings.url.replace('/Employee', '/Maintenance');
    }
}